import styled from "styled-components";

import Icon from "@/components/SharedComponents/Icon.deprecated";

const InputIcon = styled(Icon)`
  position: absolute;
  pointer-events: none;
`;

export default InputIcon;
